import { KendoBaseComponent, KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'
import ContextMenuProps from './ContextMenuProps'

import Animation from './Animation'

export default {
    template: '<ul><slot></slot></ul>',
    props: ContextMenuProps,
    mixins: [
        KendoBaseComponent,
        KendoSharedMethods,
        Animation
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoContextMenu(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoContextMenu()
        },
        _resolveChildren() {
            if(this.$options.propsData && !this.$options.propsData['dataSource'] && this.$slots.default){
                var items = this.resolveInnerTags('kendo-menu-item')

                if(items.length) {
                    this.widgetOptions['dataSource'] = items
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoContextMenu/KendoContextMenuMixin.js